import { AfterViewInit, ChangeDetectionStrategy, Component } from '@angular/core';
import { Toast } from 'ngx-toastr';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class ToastComponent extends Toast implements AfterViewInit {

  public ngAfterViewInit(): void {
    setTimeout(this.remove.bind(this), 8000);
  }
}

